import apiService from "../services/apiService";
const loginObj = JSON.parse(localStorage.getItem("auth")) || {};
const endpoint = "accountingapi";

export const getData = async (url) => {
  try {
    const response = await apiService.get(
      `${endpoint}${url}?org=${loginObj.org}&is_archive=false`
    );
    return response;
  } catch (error) {
    console.error("Error fetching product categories:", error);
    // Optional: rethrow or return a fallback
    throw error; // rethrow so caller can handle if needed
  }
};
